<template>
  <aside v-if="context.debug" class="brand-debug-banner" aria-label="Brand preview mode">
    <strong>DEBUG brand preview</strong>
    <label for="brand-debug-select">Brand:</label>
    <select id="brand-debug-select" :value="context.activeBrand" @change="selectBrand">
      <option v-for="brand in previewBrands" :key="brand" :value="brand">
        {{ brand }}
      </option>
    </select>
  </aside>
</template>

<script>
import { buildBrandPreviewUrl, getBrandContext, PREVIEW_BRANDS } from '@/config/brand'

export default {
  name: 'BrandDebugBanner',
  data() {
    return {
      context: getBrandContext(),
      previewBrands: PREVIEW_BRANDS,
    }
  },
  methods: {
    selectBrand(event) {
      window.location.assign(buildBrandPreviewUrl(event.target.value))
    },
  },
}
</script>

<style scoped>
.brand-debug-banner {
  align-items: center;
  background: #5b21b6;
  color: #fff;
  display: flex;
  gap: 0.75rem;
  bottom: 0.75rem;
  min-height: 34px;
  padding: 0.35rem 1rem;
  position: fixed;
  right: 0.75rem;
  z-index: 1200;
}

.brand-debug-banner select {
  background: #fff;
  border: 0;
  border-radius: 3px;
  color: #111827;
  padding: 0.2rem 0.5rem;
}
</style>
